import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "animate.css";
import Select from 'react-select'
import { ColorChecker } from "../../Helpers/Functions/ColorChecker";

const SponsorshipPopup = ({
  users,
  visibleFields,
  team,
  custom_field_values,
  user_avatars,
  logo,
  page,
  amounts,
  user
}) => {
  const [selectedUser, setSelectedUser] = useState(users[0]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fieldValues, setFieldValues] = useState(custom_field_values)
  const [currentSelection, setCurrentSelection] = useState(null)
  const [buttonTextColor, setButtonTextColor] = useState('white')
  const [buttonColor, setButtonColor] = useState(page.button_color)

  useEffect(() => {
    if (user) {
      let shownUser = users.filter(u => u.id == user)
      if (shownUser && shownUser.length > 0) {
        setSelectedUser(shownUser[0])
        setIsModalOpen(true)
      }
    }

    let result = ColorChecker(buttonColor)
    if (result == true) setButtonTextColor('black')
  }, [])

  function canShowPublicField(customFields, field) {
    const foundField = customFields.find(
      (f) => f.system_key === field.toString()
    );
    return foundField && foundField.visible;
  }

  const getFieldValues = (user, field) => {
    if (field.system_key == 'bio') return user.bio
    const userRecords = [];

    for (const innerArray of fieldValues) {
        const matchingRecords = innerArray.filter(value => value.record_id == user.id);
        userRecords.push(...matchingRecords);
    }
    if (!userRecords) return null

    let valueObject = userRecords.find(record => record.team_custom_field_id == field.id)
    if (valueObject) return valueObject.value 
    return null
  }

  const getUserAvatar = (user) => {
    const matchingRecord = user_avatars.find(
      (record) => record.user_id === user.id
    );

    if (matchingRecord.user_avatar != null) {
      return matchingRecord.user_avatar;
    }
  };

  const defineAge = (birthday) => {
    if (!birthday) {
      return "";
    }
    const age = Math.floor(
      (new Date() - new Date(birthday)) / (365 * 24 * 60 * 60 * 1000)
    );
    return age.toString();
  };

  const getAmounts = (amount = null) => {
    if (amount) {
      if (page.pass_processing_fee) {
        let fee = amount.amount * 0.034 + 0.3;
        return fee + amount.amount;
      }
      return amount.amount;
    } else {
      if (page.pass_processing_fee) {
        let fee = page.general_sponsorship_amount * 0.034 + 0.3;
        return page.general_sponsorship_amount + fee;
      }

      return page.general_sponsorship_amount;
    }
  };

  const unpaidSponsorshipsCount = (id) => {
    let sponsorships = amounts.filter(amount => amount.user_id == id && !amount.paid)
    return sponsorships.length > 0 ? sponsorships.length : 1
  }

  const totalSponsorshipCount = (id) => {
    let sponsorships = amounts.filter(amount => amount.user_id == id)
    return sponsorships.length > 0 ? sponsorships.length : 1
  }

  const userSponsorshipAmount = (user) => {
    let sponsorships = amounts.filter(amount => amount.user_id == user.id && !amount.paid)
    return sponsorships.length > 0 ? sponsorships : false
  }

  const handleInputChange = (value) => {
      setCurrentSelection(value)
  }

  const handleStaticChange = (value) => {

  }

  const visitSponsorPage = (user) => {
      let userSponsorships = amounts.filter(amount => amount.user_id == user.id && !amount.paid)
      if (!userSponsorships || (userSponsorships && userSponsorships.length < 1)) {
          window.location = `/sponsor/${team.id}/${user.id}/${page.id}/signup/new`
          return
      } else {
          let sponsorshipsWithId = userSponsorships.filter(amount => currentSelection && amount.id == currentSelection.id)
          if (sponsorshipsWithId && sponsorshipsWithId.length > 0) {
              window.location = `/sponsor/${team.id}/${user.id}/${page.id}/signup/new?sponsorship_id=${sponsorshipsWithId[0].id}`
              return
          } else {
              window.location = `/sponsor/${team.id}/${user.id}/${page.id}/signup/new?sponsorship_id=${userSponsorships[0].id}`
              return
          }
      }
  }

  const copyPageLink = (user) => {
    let url = window.location.protocol + "//" + window.location.host + window.location.pathname;
    url = `${url}?preview=1&user=${user.id}`;
  
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(() => {
        Alert.show('notice', 'Copied to clipboard');
      }).catch((error) => {
        // Clipboard API failed, use a fallback method
        console.error('Clipboard writeText error:', error);
        fallbackCopyTextToClipboard(url);
      });
    } else {
      // Clipboard API not available, use a fallback method
      fallbackCopyTextToClipboard(url);
    }
  }
  
  function fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
  
    try {
      document.execCommand('copy');
      Alert.show('notice', 'Copied to clipboard');
    } catch (err) {
      console.error('Fallback copy failed:', err);
    }
  
    document.body.removeChild(textArea);
  }
  

  return (
    <div>
      <div className="row row-projects">
        {users.map((user) => {
          let avatar = getUserAvatar(user);
          return (
            <div className="col-sm-6 col-lg-3" key={user.id}>
              <div className="card">
                {avatar && (
                  <div className="p-2">
                    <img
                      src={avatar}
                      className="card-img-top rounded sponsorship-template-image-landing"
                    />
                  </div>
                )}
                <div className="card-body pt-2 text-center">
                  <h4 className="mb-1 fw-bold">
                    {canShowPublicField(visibleFields, "first_name") &&
                      `${user.first_name} `}

                    {canShowPublicField(visibleFields, "last_name") &&
                      `${user.last_name}`}
                  </h4>

                  {page.general_sponsorship_amount && unpaidSponsorshipsCount(user.id) > 1 &&
                    <p className='mb-0' style={{fontSize: '13px', textAlign: 'center'}}>
                      <b>{`${unpaidSponsorshipsCount(user.id)} of ${totalSponsorshipCount(user.id)} sponsorships available`}</b>
                    </p>
                  }

                  {page.general_sponsorship_amount && userSponsorshipAmount(user) && userSponsorshipAmount(user).length > 1 &&
                        <div className='form-group'>
                            <div className="input-group">
                                <Select
                                    className="w-100 select-audience"
                                    classNamePrefix="select-audience"
                                    value={currentSelection ? currentSelection : userSponsorshipAmount(user)[0]}
                                    onChange={(value) => handleInputChange(value)}
                                    options={userSponsorshipAmount(user)}
                                    getOptionLabel={option => `$${getAmounts(option)} / Month`}
                                    getOptionValue={option => option.id }
                                />
                            </div>
                        </div>
                    }

                    {/* Only one sponsorship amount available */}
                    {page.general_sponsorship_amount && userSponsorshipAmount(user) && userSponsorshipAmount(user).length == 1 &&
                      <div className='mt-3' style={{textAlign: 'center'}}>
                          <h5>Sponsor: {`$${getAmounts(userSponsorshipAmount(user)[0])} / Month`}</h5>
                      </div>
                    }
                    
                    {page.general_sponsorship_amount && !userSponsorshipAmount(user) &&
                      <div className='mt-3' style={{textAlign: 'center'}}>
                        <h5>Sponsor: {`$${getAmounts()} / Month`}</h5>
                      </div>
                    }

                  <a
                    className="btn btn-sm mr-2"
                    onClick={() => {
                      setSelectedUser(user);
                      setIsModalOpen(true);
                    }}
                    style={{ color: page.button_color, borderColor: page.button_color }}
                  >
                    Learn More
                  </a>
                  <a
                    className="btn btn-sm btn-primary"
                    href='#'
                    onClick={() => visitSponsorPage(user)}
                    style = {{backgroundColor: page.button_color, borderColor: page.button_color, color: buttonTextColor}}
                  >
                    {page.button_text && <>{page.button_text}</>}
                    {!page.button_text && <>Sponsor</>}
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {isModalOpen && (
        <div className="modal-sponsorship-template">
          <div className="modal-content-sponsorship-template">
            <span className="close-modal" onClick={() => setIsModalOpen(false)}>
              &times;
            </span>
            {logo && (
              <div class="sponsorship-template-logo">
                <img src={logo} alt="Nonprofit logo" />
                <span class="sr-only">{team.name}</span>
              </div>
            )}
            <div className="sponsorship-template-title text-center">
              Sponsor{" "}
              {canShowPublicField(visibleFields, "first_name") &&
                `${selectedUser.first_name} `}{" "}
              {canShowPublicField(visibleFields, "last_name") &&
                `${selectedUser.last_name}`}
            </div>
            <div className="sponsorship-template-subtitle text-center">
              {!page.use_payments && (
                <>
                  Click "{page.button_text && <>{page.button_text}</>}
                  {!page.button_text && <>Sponsor</>}" to set up your account,
                  and let us know you are interested in sponsoring
                  <strong>
                    {" "}
                    {canShowPublicField(visibleFields, "first_name") &&
                      `${selectedUser.first_name} `}{" "}
                    {canShowPublicField(visibleFields, "last_name") &&
                      `${selectedUser.last_name}`}
                  </strong>
                </>
              )}

              {page.use_payments && (
                <>
                  Click "{page.button_text && <>{page.button_text}</>}
                  {!page.button_text && <>Sponsor</>}" to set up your account
                  and sponsor
                  <strong>
                    {" "}
                    {canShowPublicField(visibleFields, "first_name") &&
                      `${selectedUser.first_name} `}
                    {canShowPublicField(visibleFields, "last_name") &&
                      `${selectedUser.last_name}`}
                  </strong>
                </>
              )}
            </div>
            <div className="row">
              <div className="col-md-1"></div>
              <div className="col-md-5 text-center">
                <img
                  src={getUserAvatar(selectedUser)}
                  className="card-img-top rounded sponsorship-template-image"
                  alt="Student Profile Picture"
                />
                <div className="sponsorship-template-name">
                  {canShowPublicField(visibleFields, "first_name") &&
                    `${selectedUser.first_name} `}
                  {canShowPublicField(visibleFields, "last_name") &&
                    `${selectedUser.last_name}`}
                </div>
                <div className="sponsorship-template-age">
                  {canShowPublicField(visibleFields, "birthday") &&
                    selectedUser.birthday != null &&
                    selectedUser.birthday +
                      " (" +
                      defineAge(selectedUser.birthday) +
                      " years old)"}
                </div>

                {page.general_sponsorship_amount && unpaidSponsorshipsCount(selectedUser.id) > 1 &&
                  <p className='mb-0'><b>{`${unpaidSponsorshipsCount(selectedUser.id)} of ${totalSponsorshipCount(selectedUser.id)} sponsorships available`}</b></p>
                }

                {page.general_sponsorship_amount && userSponsorshipAmount(selectedUser) && userSponsorshipAmount(selectedUser).length > 1 &&
                    <div className='form-group' style={{maxWidth: '200px', margin: 'auto'}}>
                        <div className="input-group">
                            <Select
                                className="w-100 select-audience"
                                classNamePrefix="select-audience"
                                value={currentSelection ? currentSelection : userSponsorshipAmount(selectedUser)[0]}
                                onChange={(value) => handleInputChange(value)}
                                options={userSponsorshipAmount(selectedUser)}
                                getOptionLabel={option => `$${getAmounts(option)} / Month`}
                                getOptionValue={option => option.id }
                            />
                        </div>
                    </div>
                }

                {/* Only one sponsorship amount available */}
                {page.general_sponsorship_amount && userSponsorshipAmount(selectedUser) && userSponsorshipAmount(selectedUser).length == 1 &&
                  <div className='mt-3' style={{textAlign: 'center'}}>
                      <h5 style={{marginBottom: '0px'}}>Sponsor: {`$${getAmounts(userSponsorshipAmount(selectedUser)[0])} / Month`}</h5>
                  </div>
                }
                
                {page.general_sponsorship_amount && !userSponsorshipAmount(selectedUser) &&
                  <div className='mt-3' style={{textAlign: 'center'}}>
                    <h5 style={{marginBottom: '0px'}}>Sponsor: {`$${getAmounts()} / Month`}</h5>
                  </div>
                }
                <a
                  className="btn btn-sm btn-primary mt-3"
                  href="#"
                  onClick={() => visitSponsorPage(selectedUser)}
                  style = {{backgroundColor: page.button_color, borderColor: page.button_color, color: buttonTextColor}}
                >
                  {page.button_text && <>{page.button_text}</>}
                  {!page.button_text && <>Sponsor</>}
                </a>
                <a className="btn btn-sm mt-3 ml-1" href="#" onClick={() => copyPageLink(selectedUser)} style={{ color: page.button_color, borderColor: page.button_color }}>
                  <i class="fas fa-share-square"></i> Share
                </a>
              </div>
              <div className="col-md-5 text-left">
                {visibleFields.map((field) => {
                  if (
                    field.system_key === "first_name" ||
                    field.system_key === "last_name" ||
                    field.system_key === "birthday"
                  ) {
                    return null;
                  }

                  const value = getFieldValues(selectedUser, field);
                  return (
                    <div>
                      {value != "" && (
                        <div
                          key={field.id}
                          className="mb-2 sponsorship-template-fields"
                        >
                          <p className="text-bold small sponsorship-template-field-name">
                            {field.name}
                          </p>
                          {value ? (
                            <p className="text-muted small sponsorship-template-field-value">
                              {field.value_type == 'link' &&
                                 <a href={value} target="_blank">{ field.anchor_text ? field.anchor_text : field.name }</a> 
                              }
                              {field.value_type !== 'link' &&
                                <span>{value}</span>
                              }
                            </p>
                          ) : (
                            <p className="text-muted small sponsorship-template-field-value">
                              No data available.
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              <div className="col-md-1"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

SponsorshipPopup.propTypes = {
  close: PropTypes.func,
};

export default SponsorshipPopup;
